export default __webpack_public_path__ + "static/media/placeholder.7d7b0b15.jpg";